import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
import { obx, computed, makeObservable } from '@alilc/lowcode-editor-core';
import { uniqueId } from '@alilc/lowcode-utils';
import { intl } from '../../locale';
// modals assoc x-hide value, initial: check is Modal, yes will put it in modals, cross levels
// if-else-if assoc conditionGroup value, should be the same level,
// and siblings, need renderEngine support
export var ExclusiveGroup = (_dec = obx.shallow, (_class = /*#__PURE__*/function () {
  function ExclusiveGroup(name, title) {
    this.name = name;
    this.isExclusiveGroup = true;
    this.id = uniqueId('exclusive');
    this.title = void 0;
    _initializerDefineProperty(this, "children", _descriptor, this);
    _initializerDefineProperty(this, "visibleIndex", _descriptor2, this);
    makeObservable(this);
    this.title = title || {
      type: 'i18n',
      intl: intl('Condition Group')
    };
  }
  var _proto = ExclusiveGroup.prototype;
  _proto.add = function add(node) {
    var _node$nextSibling$con;
    if (node.nextSibling && ((_node$nextSibling$con = node.nextSibling.conditionGroup) === null || _node$nextSibling$con === void 0 ? void 0 : _node$nextSibling$con.id) === this.id) {
      var i = this.children.indexOf(node.nextSibling);
      this.children.splice(i, 0, node);
    } else {
      this.children.push(node);
    }
  };
  _proto.remove = function remove(node) {
    var i = this.children.indexOf(node);
    if (i > -1) {
      this.children.splice(i, 1);
      if (this.visibleIndex > i) {
        this.visibleIndex -= 1;
      } else if (this.visibleIndex >= this.children.length) {
        this.visibleIndex = this.children.length - 1;
      }
    }
  };
  _proto.setVisible = function setVisible(node) {
    var i = this.children.indexOf(node);
    if (i > -1) {
      this.visibleIndex = i;
    }
  };
  _proto.isVisible = function isVisible(node) {
    var i = this.children.indexOf(node);
    return i === this.visibleIndex;
  };
  _createClass(ExclusiveGroup, [{
    key: "document",
    get: function get() {
      return this.visibleNode.document;
    }
  }, {
    key: "zLevel",
    get: function get() {
      return this.visibleNode.zLevel;
    }
  }, {
    key: "length",
    get: function get() {
      return this.children.length;
    }
  }, {
    key: "visibleNode",
    get: function get() {
      return this.children[this.visibleIndex];
    }
  }, {
    key: "firstNode",
    get: function get() {
      return this.children[0];
    }
  }, {
    key: "index",
    get: function get() {
      return this.firstNode.index;
    }
  }]);
  return ExclusiveGroup;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "children", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "visibleIndex", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "document", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "document"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zLevel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "length", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "length"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleNode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visibleNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstNode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstNode"), _class.prototype)), _class));
export function isExclusiveGroup(obj) {
  return obj && obj.isExclusiveGroup;
}